import React from 'react';
import { makeStyles } from '@material-ui/core';
import { MDSButton, MDSDivider, MDSDropdownItem, MDSIcon, MDSTypography } from '@marqvision/mds-v2';
import { MarqAiClientSelector } from '@marqvision/shared';
import { useAuth, useClientViewClientsQuery, useUserInfoQuery } from '~/apis/auth';
import { AuthProtocolsGetClientViewClientsResponse } from '~/swagger/data-contracts';

const useStyles = makeStyles(({ color }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    height: '48px', // client-view-header 높이
    backgroundColor: color.bg.surface.inverse.light,
    position: 'relative',
    zIndex: 100,
    padding: '0 24px',
  },
}));

type Props = {
  logo: React.ReactElement;
};

export const ClientViewHeader = (props: Props) => {
  const classes = useStyles();
  const { data: auth } = useAuth();
  const { data: userInfo } = useUserInfoQuery();
  const { logo } = props;

  const { data: clientList, isLoading } = useClientViewClientsQuery({
    select: parseClientList,
  });

  const handleClientSelect = (clientId: number) => {
    window.open(
      `/dashboard/${auth?.access_token}/${auth?.refresh_token}/${userInfo?.user_email}/${clientId}`,
      '_blank'
    );
  };

  return (
    <div className={classes.root}>
      {logo}
      <MDSDivider orientation="vertical" length={16} />
      <MDSTypography size="l" weight="medium" color="color/content/on_default_color">
        Client view
      </MDSTypography>
      {userInfo && (
        <MarqAiClientSelector
          value={{ clientId: userInfo.client_id }}
          onSelect={handleClientSelect}
          list={clientList || []}
          isLoading={isLoading}
          anchor={
            <MDSButton variant="tint" color="white" endIcon={<MDSIcon.ArrowDown variant="outline" />}>
              #{userInfo.client_id}: {userInfo.client_name}
            </MDSButton>
          }
        />
      )}
    </div>
  );
};

const parseClientList = (data: AuthProtocolsGetClientViewClientsResponse) => {
  return data.client_list.map((client) => {
    return {
      value: client.id,
      label: client.name,
      isActive: client.is_active,
      subLabel: { label: client.id, position: 'top' } as MDSDropdownItem<number>['subLabel'],
      children: client.brand_name_list.map((brand, index) => {
        return {
          value: `${client.id}-${index}`,
          label: brand,
          isDisabled: true,
        };
      }),
    };
  });
};
